export const DOWNLOAD_PROCESS_STATEMENT_RTF_REQUEST = 'DOWNLOAD_PROCESS_STATEMENT_RTF_REQUEST';

export const downloadProcessStatementRtfFileRequest = ({ id }) => ({
    type: DOWNLOAD_PROCESS_STATEMENT_RTF_REQUEST,
    payload: { id }
});
